import { IChatConfigData, Locale } from '../../../types/app-interfaces';

const sandboxConfigData: Record<Locale, IChatConfigData> = {
  'en-us': {
    locale: 'en-us',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_US_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENU1755859087357',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENU1755859087357/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fvan',
        checkout: '00G07000000i3PW',
        design: '00G1v000005kYqQ',
        digital: '00G0Y000004z7MW',
        msp: '00G07000000h1jl',
        ppag: '00G1v000005KMQv',
        wedding: '00G3N00000BDUqG',
      },
    },
  },
  'da-dk': {
    locale: 'da-dk',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DK_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDKC1747835659035',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDKC1747835659035/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G1v000007kdRE',
        checkout: '00G07000000F1Rg',
        design: '00G07000000hYBO',
        digital: '00G1v000007kdRE',
      },
    },
  },
  'de-at': {
    locale: 'de-at',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_AT_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDEA1749639004055',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDEA1749639004055/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEn',
        checkout: '00G07000000F1Rd',
        design: '00G07000000hEyf',
        digital: '00G41000000fxEn',
      },
    },
  },
  'de-ch': {
    locale: 'de-ch',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_CH_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDEC1749638715011',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDEC1749638715011/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEx',
        checkout: '00G07000000F1Re',
        design: '00G07000000hEyg',
        digital: '00G41000000fxEx',
      },
    },
  },
  'de-de': {
    locale: 'de-de',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_DE_DE_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDED1749638594531',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWDED1749638594531/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEi',
        checkout: '00G07000000F1Rf',
        design: '00G1v000006WqQ7',
        digital: '00G41000000fxEi',
      },
    },
  },
  'en-au': {
    locale: 'en-au',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_AU_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENA1745838261839',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENA1745838261839/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxEd',
        checkout: '00G07000000F1Rh',
        design: '00G1v000005KGMN',
        digital: '00G1v000005NvE4',
      },
    },
  },
  'en-ca': {
    locale: 'en-ca',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_CA_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENC1754062264696',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENC1754062264696/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T5kR',
        checkout: '00G07000000F1Ri',
        design: '00G07000000hD9M',
        digital: '00G1v000005NrXM',
        wedding: '00G07000000qlo5',
      },
    },
  },
  'en-gb': {
    locale: 'en-gb',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_UK_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWUKC1754738102613',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWUKC1754738102613/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxGP',
        checkout: '00G07000000i3PV',
        design: '00G1v00000550lC',
        digital: '00G41000000fxGP',
      },
    },
  },
  'en-ie': {
    locale: 'en-ie',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_IE_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENI1747049623879',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENI1747049623879/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aA',
        checkout: '00G07000000F1Rj',
        design: '00G1v000007jkVU',
        digital: '00G0Y000000T6aA',
      },
    },
  },
  'en-nz': {
    locale: 'en-nz',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_EN_NZ_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENN1744803533581',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWENN1744803533581/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aCUAS',
        checkout: '00G07000000F1RkEAK',
        design: '00G1v000005KGMPEA4',
        digital: '00G1v000005NvE6EAK',
      },
    },
  },
  'en-sg': {
    locale: 'en-sg',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'Vistaprint_MIAW_EN_SG',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725',
      initURL: 'https://vpcare--full.sandbox.my.site.com/ESWVistaprintMIAWENSG1738135819725/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Ov',
        checkout: '00G07000000F1Rl',
        design: '00G07000000h8cq',
        digital: '00G07000000h2Ov',
      },
    },
  },
  'es-es': {
    locale: 'es-es',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_ES_ES_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWESE1749836071541',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWESE1749836071541/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFH',
        checkout: '00G07000000F1Rm',
        design: '00G1v000007jkVT',
        digital: '00G41000000fxFH',
      },
    },
  },
  'es-us': {
    locale: 'es-us',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_ES_US_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWESU1756102060427',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWESU1756102060427/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6a9',
        checkout: '00G07000000F1Rn',
        design: '00G0Y000000T6a9',
        digital: '00G1v000007jYAe',
        msp: '00G9Q0000049bnd',
      },
    },
  },
  'fi-fi': {
    locale: 'fi-fi',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FI_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFIC1747693278001',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFIC1747693278001/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Cn',
        checkout: '00G07000000F1Ro',
        design: '00G07000000hYBP',
        digital: '00G07000000h2Cn',
      },
    },
  },
  'fr-be': {
    locale: 'fr-be',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_BE_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRB1753956438006',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRB1753956438006/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFW',
        checkout: '00G07000000F1Rp',
        design: '00G07000000hUdO',
        digital: '00G41000000fxFW',
      },
    },
  },
  'fr-ca': {
    locale: 'fr-ca',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_CA_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1754302264169',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1754302264169/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFg',
        checkout: '00G07000000F1Rq',
        design: '00G07000000h9M9',
        digital: '00G41000000fxFg',
      },
    },
  },
  'fr-ch': {
    locale: 'fr-ch',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_CH_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1749836198291',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1749836198291/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFl',
        checkout: '00G07000000F1Rr',
        design: '00G07000000hEyh',
        digital: '00G41000000fxFl',
      },
    },
  },
  'fr-fr': {
    locale: 'fr-fr',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_FR_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1753716582679',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWFRC1753716582679/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fnFR',
        checkout: '00G07000000F1Rs',
        design: '00G1v00000550kx',
        digital: '00G41000000fnFR',
      },
    },
  },
  'it-ch': {
    locale: 'it-ch',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_IT_CH_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWITC1749835454545',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWITC1749835454545/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G0Y000000T6aB',
        checkout: '00G07000000F1Rt',
        design: '00G07000000hEyj',
        digital: '00G0Y000000T6aB',
      },
    },
  },
  'it-it': {
    locale: 'it-it',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_IT_IT_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWITI1749835305635',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWITI1749835305635/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxFv',
        checkout: '00G07000000F1Ru',
        design: '00G07000000hAnT',
        digital: '00G41000000fxFv',
      },
    },
  },
  'nb-no': {
    locale: 'nb-no',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NO_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNOC1747835984872',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNOC1747835984872/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G07000000h2Co',
        checkout: '00G07000000F1Rx',
        design: '00G07000000hYBQ',
        digital: '00G07000000h2Co',
      },
    },
  },
  'nl-be': {
    locale: 'nl-be',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NL_BE_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNLB1749835921178',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNLB1749835921178/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxG5',
        checkout: '00G07000000F1Rv',
        design: '00G07000000hUdP',
        digital: '00G41000000fxG5',
      },
    },
  },
  'nl-nl': {
    locale: 'nl-nl',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_NL_NL_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNLN1749835548574',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWNLN1749835548574/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G41000000fxG0',
        checkout: '00G07000000F1Rw',
        design: '00G07000000hUdQ',
        digital: '00G41000000fxG0',
      },
    },
  },
  'sv-se': {
    locale: 'sv-se',
    checkBusinessHour: false,
    sfConfig: {
      orgId: '00D3N000000HG1U',
      scrt2URL: 'https://vpcare--full.sandbox.my.salesforce-scrt.com',
      eswConfigDevName: 'ChatAnywhere_MIAW_SE_Chat',
      siteURL: 'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWSEC1747836217565',
      initURL:
        'https://vpcare--full.sandbox.my.site.com/ESWChatAnywhereMIAWSEC1747836217565/assets/js/bootstrap.min.js',
      queueInfo: {
        default: '00G1v000007kdRF',
        checkout: '00G07000000F1Ry',
        design: '00G07000000hYBR',
        digital: '00G1v000007kdRF',
      },
    },
  },
};
export const getSandboxConfig = (locale: Locale): IChatConfigData => ({ ...sandboxConfigData[locale], env: 'sandbox' });
